/* eslint-disable @typescript-eslint/no-explicit-any */
import { PrivateEndpoint, PublicEndpoint } from './endpoint.class';

/**
 * Endpoints for Programs
 */
class ProgramEndpoint {
  public getPrograms = new PublicEndpoint('/program/all');
  public putUpdateProgram = new PrivateEndpoint('/program/%1s'); // %1s : program id
}

/**
 * Endpoints for config
 */
class ConfigEndpoint {
  public getConfig = new PublicEndpoint('/app-config');
}

/**
 * Endpoints for UI
 */
class UiEndpoint {
  public getQrCode = new PublicEndpoint('/qr-code');
}

/**
 * Endpoints for password managment
 */
class PasswordEndpoint {
  public postForgottenPass = new PublicEndpoint('/password/forgotten');
  public postCheckPassSecurityLevel = new PublicEndpoint('/password/security-level');
}

/**
 * Endpoints for Authentication
 */
class AuthEndpoint {
  public postAuth = new PublicEndpoint('/auth');
  public postAuthRefresh = new PublicEndpoint('/auth/refresh');
}

/**
 * Endpoints for Administration
 */
class AdminEndpoint {
  public getUsers = new PrivateEndpoint('/admin/users');
  public postAddUser = new PrivateEndpoint('/admin/user');
  public postPasswordRenew = new PrivateEndpoint('/admin/user/password');
  public postResendValidationLink = new PrivateEndpoint('/admin/user/resend-validation-link');
  public putUpdateUserRoles = new PrivateEndpoint('/admin/user/roles');
  public putUpdateUser = new PrivateEndpoint('/admin/user');
  public deleteUser = new PrivateEndpoint('/admin/user/%1s');
}

/**
 * Endpoints for User
 */
class UserEndpoint {
  public postUpdatePassword = new PrivateEndpoint('/user/password');
  public postUpdateUsername = new PrivateEndpoint('/user/username');
  public postLoggout = new PrivateEndpoint('/user/loggout');
}

/**
 * Endpoints for Video
 */
class VideoEndpoint {
  public getVideoForChromecast = new PublicEndpoint('/video/cast/%1s/%2s'); // %1S : video id; %2S : refreshToken
  public getStreamedVideo = new PrivateEndpoint('/video/stream/%1s'); // %1S : video id
  public uploadVideo = new PrivateEndpoint('/video/upload');
  public publicUploadVideo = new PublicEndpoint('/video/upload');
  public postVideo = new PrivateEndpoint('/video/uploaded');
  public putValidateVideo = new PrivateEndpoint('/video/validate/%1s'); // %1S : video id
  public putInvalidateVideo = new PrivateEndpoint('/video/invalidate/%1s'); // %1S : video id
  public putAskToValidateVideo = new PrivateEndpoint(
    '/video/ask-to-validate/%1s',
  ); // %1S : video id
  public deleteVideo = new PrivateEndpoint('/video/%1s'); // %1S : video id
}

/**
 * Endpoints for Health check
 */
class HeakthCheckEndpoint {
  public getLiveness = new PublicEndpoint('/liveness');
}

/**
 * Endpoints for Contact
 */
class ContactEndpoint {
  public postMessage = new PublicEndpoint('/contact');
}

/**
 * Endpoints for Release
 */
class ReleaseEndpoint {
  public getChangelog = new PublicEndpoint('/changelog');
}

/**
 * Endpoints for Signup
 */
class SignupEndpoint {
  public postSignup = new PublicEndpoint('/signup');
  public postSignupAccept = new PrivateEndpoint('/signup/accept');
  public postSignupReject = new PrivateEndpoint('/signup/reject');
}

/**
 * Endpoints for Security
 */
class SecurityEndpoint {
  public getCsrf = new PublicEndpoint('/csrf');
}

/**
 * Main class
 */
class MainEndpoint {
  // Programs
  public programs = new ProgramEndpoint();

  // Authentication
  public authentication = new AuthEndpoint();

  // Password managment
  public password = new PasswordEndpoint();

  // App configuration
  public config = new ConfigEndpoint();

  // Releases
  public release = new ReleaseEndpoint();

  // App UI
  public ui = new UiEndpoint();

  // Administration
  public admin = new AdminEndpoint();

  // User
  public user = new UserEndpoint();

  // User
  public video = new VideoEndpoint();

  // HealthCheck
  public healthCheck = new HeakthCheckEndpoint();

  // Contact
  public contact = new ContactEndpoint();

  // Signup
  public signup = new SignupEndpoint();

  // Security
  public security = new SecurityEndpoint();
}

export default new MainEndpoint();
